import { Flex } from 'antd';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { css } from 'config/emotionCss';

import { b } from 'utils/i18nUtils';

type ArchiveMediaDisplayProps = {
    isDefrosting: boolean;
    handleOnClick: () => void;
}

const containerStyle = css`                                                   
    min-height: 400px;
`;

const formattedMessageValues = { br: <br />, b };

const ArchiveMediaDisplay: React.FC<ArchiveMediaDisplayProps> = ({ isDefrosting, handleOnClick }) => (
  <Flex
    vertical
    align="center"
    justify="center"
    className={classNames(containerStyle, 'p-5 m-auto text-center')}
    data-cy={isDefrosting ? 'restoring-media-message' : 'archived-media-message'}
    onClick={handleOnClick}
  >
    <span className="fb-icon--no-media text-6xl mb-2" />
    {isDefrosting && <FormattedMessage
      id="archivedMedias.defrosting"
      defaultMessage="<b>Request sent! The media will be available again within a maximum of 12 hours.</b>"
      values={formattedMessageValues}
    />}
    {!isDefrosting && <FormattedMessage
      id="archivedMedias.archived"
      defaultMessage="<b>The media has been archived and is no longer available immediately.</b>{br}You can retrieve it via the link in the warning banner.{br} You will receive an email within a maximum of 12 hours when the media is available again."
      values={formattedMessageValues}
    />}
  </Flex>);

export default ArchiveMediaDisplay;
